import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as PageContext } from '../../../contexts/PageContext';
import JobsSearchLanding from './JobsSearchLanding';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};
ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PageContext PAGE_PROPS={props.PAGE_PROPS}>
        <JobsSearchLanding {...props} />
    </PageContext>
);
